<template>
  <audio v-if="currUrl" id="uuidAudio"
         @canplay="canplay"
         @timeupdate="timeupdate"
         @ended="ended"
         ref="audio"
         :src="currUrl" @pause="pause"></audio>
</template>

<script>
import {debug} from "../lib/util";
import {audioPlayStatusCache} from "../lib/cache";

export default {
  name: 'app-audio',
  props: ['url'],
  data() {
    return {
      time: 0,
      currUrl: '',
      oldUrl: ''
    };
  },
  computed: {},
  components: {},
  mounted() {
  },
  beforeDestroy() {
  },
  watch: {
    url(newV, oldV) {
      this.oldUrl = oldV;
    }
  },
  methods: {
    audioPlay() {
      const el = this.$refs.audio;
      if (!el || !this.currUrl) {
        setTimeout(this.audioPlay, 20);
      } else {
        el.play();
        if (el.readyState < 3) {
          setTimeout(this.audioPlay, 20);
        }
      }
    },
    play() {
      Log('new-old-url', this.url, this.oldUrl);
      if (!this.oldUrl) {
        Log('处理前time', Date.now(), this.url)
        if (!this.url) return;
        const now = Date.now();
        if (now - this.time < 1000) {
          return;
        }
        this.time = now;
        Log('处理后time', now, this.url)
        this.currUrl = this.url;
        this.audioPlay();
      } else {
        Log('new-old-url', '旧音频处理', this.oldUrl, this.url);
        let el = this.$refs.audio;
        if (el) {
          Log('new-old-url', '旧音频处理', el.src);
          if (el.src === this.oldUrl) {
            el.pause();
            if (el.paused) {
              Log('new-old-url', '旧音频处理', el.paused);
              audioPlayStatusCache.set({url: this.oldUrl, status: 'end'});
              this.currUrl = this.url;
              this.audioPlay()
            }
          } else {
            this.currUrl = this.url;
            this.audioPlay()
          }
          console.dir(el);
        } else {
          setTimeout(() => this.play(), 20)
        }
      }
    },

    loadstart() {
      debug("loadstart");
    },

    canplay() {
      debug("canplay");
      audioPlayStatusCache.set({url: this.currUrl, status: 'canplay'});
    },
    pause() {
      Log('new-old-url', '旧音频处理', this.currUrl, 'paused');
    },

    timeupdate() {
      let el = this.$refs.audio;
      audioPlayStatusCache.set({url: this.currUrl, status: 'playing'});
      debug("playing--", el.currentTime);
    },

    ended() {
      audioPlayStatusCache.set({url: this.currUrl, status: 'ended'});
      this.$emit('ended');
    }
  }
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/plugins/audio.vue